import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { SrIcon } from "@/components/ui/SrIcon";
import SignalAgentFormDialog from "@/components/salgsmuligheter/agents/SignalAgentFormDialog";
import SignalAgentsTable from "@/components/salgsmuligheter/agents/SignalAgentsTable";
import { useSignalAgentHits, useSignalAgents } from "@/hooks/use-signal-agents";
import { useSystemConfigNumber } from "@/hooks/use-system-config";
import type { DBSignalAgent } from "@/lib/db-types";

// Fallback når system_config ikke er lest ennå; samme verdi som seedet.
const FALLBACK_CAP_NOK = 300;

/** Agenter-fanen under Salgsmuligheter (CRM-3.3). Rendres bak feature_crm_signaler. */
export default function AgentsTab() {
  const { data: agents = [], isLoading } = useSignalAgents();
  const { data: hits = new Map<string, number>() } = useSignalAgentHits();
  const { data: defaultCap } = useSystemConfigNumber("crm_agent_cost_cap_default_nok");
  const [editing, setEditing] = useState<DBSignalAgent | undefined>();
  const [open, setOpen] = useState(false);

  const openDialog = (agent?: DBSignalAgent) => {
    setEditing(agent);
    setOpen(true);
  };

  return (
    <section className="space-y-4">
      <div className="flex items-center justify-between gap-3">
        <p className="max-w-2xl text-sm text-muted-foreground">
          Agenter leser kildene for overvåkede kunder og lager et ferdig kort i køen når de finner noe. Prøvekjør en ny agent før du lagrer den.
        </p>
        <Button onClick={() => openDialog()} aria-label="Ny agent">
          <SrIcon name="plus" className="mr-1.5 h-4 w-4" /> Ny agent
        </Button>
      </div>
      {isLoading ? (
        <Skeleton className="h-48" />
      ) : agents.length === 0 ? (
        <p className="rounded border border-dashed border-border p-4 text-sm">
          Ingen agenter ennå. Trykk «Ny agent» for å lage den første.
        </p>
      ) : (
        <SignalAgentsTable agents={agents} hits={hits} defaultCapNok={defaultCap ?? FALLBACK_CAP_NOK} onEdit={openDialog} />
      )}
      <SignalAgentFormDialog open={open} onOpenChange={setOpen} agent={editing} />
    </section>
  );
}
